var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16669 3.3332H5.66669C4.26656 3.3332 3.56649 3.3332 3.03171 3.60568C2.56131 3.84536 2.17885 4.22782 1.93917 4.69822C1.66669 5.233 1.66669 5.93307 1.66669 7.3332V14.3332C1.66669 15.7333 1.66669 16.4334 1.93917 16.9682C2.17885 17.4386 2.56131 17.821 3.03171 18.0607C3.56649 18.3332 4.26656 18.3332 5.66669 18.3332H12.6667C14.0668 18.3332 14.7669 18.3332 15.3017 18.0607C15.7721 17.821 16.1545 17.4386 16.3942 16.9682C16.6667 16.4334 16.6667 15.7333 16.6667 14.3332V10.8332M6.66666 13.3332H8.06212C8.46977 13.3332 8.67359 13.3332 8.86541 13.2871C9.03547 13.2463 9.19804 13.179 9.34716 13.0876C9.51536 12.9845 9.65948 12.8404 9.94773 12.5521L17.9167 4.5832C18.607 3.89284 18.607 2.77355 17.9167 2.0832C17.2263 1.39284 16.107 1.39284 15.4167 2.0832L7.44772 10.0521C7.15946 10.3404 7.01534 10.4845 6.91227 10.6527C6.82088 10.8018 6.75354 10.9644 6.71271 11.1345C6.66666 11.3263 6.66666 11.5301 6.66666 11.9378V13.3332Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d73d5d3c6db59d56fd60177463ea3dad.svg";
export { ForwardRef as ReactComponent };